import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.einlasskontrolle-rolle';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleEinlasskontrolleRolleEffects {

    EinlasskontrolleRolle$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_EINLASSKONTROLLE_ROLLE),
        mergeMap((x: ac.GetEinlasskontrolleRolleAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getEinlasskontrolleRolle(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetEinlasskontrolleRolleErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetEinlasskontrolleRolleFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleQueryService);
        }
        return this.service;
    }
}
